import {
    getData,
    store,
    update,
    destroy,
    getGuidanceById,
    getDataFromStudent,
    getDataKRS,
    getDataKRSFromStudent,
    storeKRS,
    updateDetailKRS,
    deleteKRS,
    acceptedByLecture,
    rejectWithRecomendation,
    studyCourseByGuidanceId
} from '@/store/api/GuidanceController'
const initialState = () => ({
    guidances: {last_page: 0,data: [], total: 0},
    studycourses: [],
    student: {},
    guidance: {},
    response: {},
    request: {
        page: 1,
        show: 10,
        sortBy: "created_at",
        sorting: "DESC",
        semester: null,
        search: null,
        type: 1
    },
})
const state = initialState
const getters = {
    getGuidances: state => state.guidances,
    getGuidance: state => state.guidance,
    getRequest: state => state.request,
    getStudent: state => state.student,
    getStudyCourses: state => state.studycourses,
    getResponse: state => state.response
}

const actions = {
    async getData({commit }, {request, url}) 
    {
        try {
            state.request = request
            var response = await getData(request, url);
            commit('SET_GUIDANCES', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async studyCourseByGuidanceId({commit }, {guidance_id, student_id = null}) 
    {
        try {
            var response = await studyCourseByGuidanceId(guidance_id, student_id);
            commit('SET_STUDYCOURSES', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataFromStudent({commit }, {request, student_id, url}) 
    {
        try {
            state.request = request
            var response = await getDataFromStudent(request,student_id, url);
            commit('SET_GUIDANCES_FROMSTUDENT', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getGuidanceById({commit }, {id, url, type = 2, student_id = null}) 
    {
        try {
            var response = await getGuidanceById(id, url, student_id, type);
            if(student_id == null){
                commit('SET_GUIDANCE', response.data);
            }else{
                commit('SET_GUIDANCE_FROMSTUDENT', response.data);
            }
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async store({commit }, {data, url}) 
    {
        try {
            var response = await store(data,url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async update({commit }, {data, id, url}) 
    {
        try {
            var response = await update(data, id, url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async destroy({commit }, {id, url}) 
    {
        try {
            var response = await destroy(id,url);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataKRS({commit }, request) 
    {
        try {
            state.request = request
            var response = await getDataKRS(request);
            commit('SET_GUIDANCES', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async getDataKRSFromStudent({commit }, {request, student_id}) 
    {
        try {
            state.request = request
            var response = await getDataKRSFromStudent(request,student_id);
            commit('SET_GUIDANCES_FROMSTUDENT', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async storeKRS({commit }, data) 
    {
        try {
            var response = await storeKRS(data);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async updateDetailKRS({commit },{data, id}) 
    {
        try {
            var response = await updateDetailKRS(data, id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async deleteKRS({commit },id) 
    {
        try {
            var response = await deleteKRS(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async acceptedByLecture({commit }, id) 
    {
        try {
            var response = await acceptedByLecture(id);
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    async rejectWithRecomendation({commit }, {id, data}) 
    {
        try {
            var response = await rejectWithRecomendation(id, {study_course_id: data});
            commit('SET_RESPONSE', response.data);
        } catch (_) {
            commit('SET_FAILED')
        }
    },
    
}

const mutations = {
    SET_FAILED(state) {
        state.response = {
            msg: 'Jaringan Bermasalah',
            status: '0'
        }
    },
    SET_RESPONSE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
    },
    SET_GUIDANCES(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.guidances = response.data
    },
    SET_GUIDANCES_FROMSTUDENT(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.guidances = response.data.guidances
        state.student = response.data.student
    },
    SET_GUIDANCE(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.guidance = response.data
    },
    SET_STUDYCOURSES(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.guidance = response.data.guidance
        state.studycourses = response.data.studyCourses
    },
    SET_GUIDANCE_FROMSTUDENT(state, response){
        state.response = {
            msg: response.msg,
            status: response.status
        }
        state.guidance = response.data.guidance
        state.student = response.data.student
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}